import LoadingSpinner from "@/components/ui/LoadingSpinner";
import { cn } from "@/util/cn";

type LoadingSectionProps = {
  className?: string;
};

export default function LoadingSection({ className }: LoadingSectionProps) {
  return (
    <section
      className={cn(
        "mx-auto max-w-sm py-40 flex items-center justify-center",
        className
      )}
    >
      <LoadingSpinner />
    </section>
  );
}
